
// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";

// function Navbar() {
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [hoveredIndex, setHoveredIndex] = useState(null);
//   const [showQR, setShowQR] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setIsScrolled(window.scrollY > 50);
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   const baseLinkStyle = {
//     fontSize: "clamp(1rem, 1vw, 1.1rem)",
//     fontWeight: "500",
//     marginRight: "10px",
//     textTransform: "uppercase",
//     color: "#5a3a0e",
//     transition: "all 0.4s ease",
//     padding: "10px 16px",
//     borderRadius: "8px",
//     display: "inline-block",
//     position: "relative",
//   };

//   const navLinks = [
//     { path: "/", label: "Home" },
//     { path: "/about", label: "About" },
//     { path: "/verses", label: "Shlokas" },
//     { path: "/healing", label: "Healing" },
//     { path: "/resources", label: "Resources" },
//     { path: "/achievements", label: "Achievements" },
//     { path: "/contact", label: "Contact" },
//   ];

//   return (
//     <>
//       <nav
//         className="navbar navbar-expand-lg"
//         style={{
//           background: isScrolled
//             ? "rgba(255, 245, 230, 0.95)"
//             : "linear-gradient(to right, #fff4dc, #ffe7ba, #ffd6b5)",
//           backdropFilter: "blur(6px)",
//           borderBottom: "1px solid rgba(255,255,255,0.4)",
//           transition: "all 0.4s ease-in-out",
//           boxShadow: isScrolled
//             ? "0 4px 10px rgba(0,0,0,0.15)"
//             : "0 0 0 rgba(0,0,0,0)",
//           padding: isScrolled ? "4px 0" : "10px 0",
//           zIndex: 1000,
//           position: "sticky",
//           top: 0,
//         }}
//       >
//         <div className="container-fluid px-3 d-flex align-items-center justify-content-between">
//           {/* 🔸 Logo + Brand */}
//           <Link
//             to="/"
//             className="navbar-brand d-flex align-items-center"
//             style={{ textDecoration: "none" }}
//           >
//             <img
//               src="/logo.jpg"
//               alt="Bhaktamar Logo"
//               style={{
//                 width: "48px",
//                 height: "48px",
//                 borderRadius: "50%",
//                 objectFit: "cover",
//                 marginRight: "10px",
//                 boxShadow: "0 4px 10px rgba(255,180,100,0.4)",
//                 transition: "all 0.4s ease",
//                 transform: isScrolled ? "scale(0.95)" : "scale(1)",
//               }}
//             />
//             <span
//               style={{
//                 fontSize: "1.5rem",
//                 fontWeight: "700",
//                 color: "#5a3a0e",
//                 letterSpacing: "1px",
//                 textShadow: "0 0 8px rgba(255,255,255,0.7)",
//               }}
//             >

//             </span>
//           </Link>

//           {/* 🔹 Mobile Toggle */}
//           <button
//             className="navbar-toggler border-0"
//             type="button"
//             data-bs-toggle="collapse"
//             data-bs-target="#navbarNav"
//           >
//             <span className="navbar-toggler-icon"></span>
//           </button>

//           {/* 🔹 Nav Links */}
//           <div
//             className="collapse navbar-collapse justify-content-end align-items-center"
//             id="navbarNav"
//           >
//             <ul
//               className="navbar-nav align-items-center"
//               style={{
//                 width: "100%",
//                 justifyContent: "flex-end",
//                 textAlign: "center",
//               }}
//             >
//               {navLinks.map((item, idx) => (
//                 <li
//                   key={idx}
//                   onMouseEnter={() => setHoveredIndex(idx)}
//                   onMouseLeave={() => setHoveredIndex(null)}
//                   className="nav-item"
//                 >
//                   <Link
//                     className="nav-link"
//                     to={item.path}
//                     style={{
//                       ...baseLinkStyle,
//                       color: hoveredIndex === idx ? "#fff" : "#4b2e05",
//                       background:
//                         hoveredIndex === idx
//                           ? "linear-gradient(90deg,#f5b45a,#e8893a)"
//                           : "transparent",
//                       transform:
//                         hoveredIndex === idx ? "translateY(-2px)" : "translateY(0)",
//                       boxShadow:
//                         hoveredIndex === idx
//                           ? "0 4px 8px rgba(233,137,58,0.3)"
//                           : "none",
//                     }}
//                   >
//                     {item.label}
//                     {/* 🔸 Animated underline */}
//                     <span
//                       style={{
//                         position: "absolute",
//                         left: 0,
//                         bottom: 2,
//                         width: hoveredIndex === idx ? "100%" : "0%",
//                         height: "2px",
//                         background: "#c26e18",
//                         transition: "width 0.3s ease",
//                       }}
//                     ></span>
//                   </Link>
//                 </li>
//               ))}

//               {/* 🪔 Yogdaan Button */}
//               {/* 🪔 Yogdaan & Certificate Buttons */}
//               <li className="nav-item d-flex align-items-center" style={{ gap: "10px" }}>
//                 {/* 🧾 Get Certificate Button */}
//                 <button
//                   onClick={() => (window.location.href = "/certificate")}
//                   style={{
//                     background: "linear-gradient(135deg, #91672c, #d9a441, #91672c)",
//                     color: "#fff",
//                     border: "none",
//                     borderRadius: "10px",
//                     padding: "8px 18px",
//                     fontWeight: "600",
//                     cursor: "pointer",
//                     boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
//                     transition: "all 0.4s ease",
//                   }}
//                   onMouseEnter={(e) =>
//                     (e.currentTarget.style.transform = "scale(1.08)")
//                   }
//                   onMouseLeave={(e) =>
//                     (e.currentTarget.style.transform = "scale(1)")
//                   }
//                 >
//                   Get Certificate
//                 </button>

//                 {/* 💰 Yogdaan Button */}
//                 <button
//                   onClick={() => setShowQR(true)}
//                   style={{
//                     background:
//                       "linear-gradient(135deg, #d97b29, #ffbb66, #d97b29)",
//                     color: "#fff",
//                     border: "none",
//                     borderRadius: "10px",
//                     padding: "8px 18px",
//                     fontWeight: "600",
//                     cursor: "pointer",
//                     boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
//                     transition: "all 0.4s ease",
//                     animation: "pulse 2.2s infinite",
//                   }}
//                   onMouseEnter={(e) =>
//                     (e.currentTarget.style.transform = "scale(1.08)")
//                   }
//                   onMouseLeave={(e) =>
//                     (e.currentTarget.style.transform = "scale(1)")
//                   }
//                 >
//                   Yogdaan
//                 </button>
//               </li>

//             </ul>
//           </div>
//         </div>

//         {/* ✨ Extra Styling */}
//         <style>
//           {`
//             @keyframes pulse {
//               0% { box-shadow: 0 0 0 0 rgba(217,123,41, 0.6); }
//               70% { box-shadow: 0 0 0 15px rgba(217,123,41, 0); }
//               100% { box-shadow: 0 0 0 0 rgba(217,123,41, 0); }
//             }
//             @media (max-width: 992px) {
//               .navbar-nav {
//                 flex-direction: column !important;
//                 align-items: center !important;
//                 gap: 6px;
//                 padding: 12px 0;
//               }
//             }
//           `}
//         </style>
//       </nav>

//       {/* 💰 Yogdaan Modal */}
//       {showQR && (
//         <div
//           onClick={() => setShowQR(false)}
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             background: "rgba(0,0,0,0.6)",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             zIndex: 2000,
//             animation: "fadeIn 0.4s ease-out",
//           }}
//         >
//           <div
//             onClick={(e) => e.stopPropagation()}
//             style={{
//               background:
//                 "linear-gradient(to bottom right, #fff9ed, #fff3d5, #fff8e5)",
//               borderRadius: "16px",
//               padding: "30px 30px",
//               textAlign: "center",
//               boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
//               maxWidth: "420px",
//               width: "90%",
//               transform: "scale(1)",
//               animation: "scaleUp 0.4s ease-out",
//             }}
//           >
//             <h4
//               style={{
//                 color: "#5a3a0e",
//                 fontWeight: "700",
//                 marginBottom: "10px",
//               }}
//             >
//               🙏 Bhaktamar Yogdaan
//             </h4>
//             <p style={{ color: "#654321", fontSize: "0.95rem" }}>
//               Your kind contribution supports new features, growth, and
//               spreading divine knowledge 🌸
//             </p>

//             {/* 🧧 QR Code */}
//             <img
//               src="/logo.jpg"
//               alt="Yogdaan QR"
//               style={{
//                 width: "220px",
//                 height: "220px",
//                 borderRadius: "10px",
//                 border: "2px solid #d6a76c",
//                 margin: "15px 0",
//                 boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//               }}
//             />

//             {/* 🏦 Bank Details */}
//             <div
//               style={{
//                 color: "#4b2e05",
//                 fontSize: "0.9rem",
//                 background: "#fff4e0",
//                 padding: "12px",
//                 borderRadius: "10px",
//                 textAlign: "left",
//                 lineHeight: "1.6",
//               }}
//             >
//               {/* <p><strong>Bank:</strong> State Bank of India</p>
//               <p><strong>Account No:</strong> -- </p>
//               <p><strong>IFSC:</strong> -- </p>
//               <p><strong>UPI ID:</strong> -- </p> */}
//             </div>

//             <button
//               onClick={() => setShowQR(false)}
//               style={{
//                 marginTop: "18px",
//                 background:
//                   "linear-gradient(90deg, #d17b2c, #f0b35c, #d17b2c)",
//                 color: "#fff",
//                 border: "none",
//                 borderRadius: "10px",
//                 padding: "8px 22px",
//                 fontWeight: "600",
//                 cursor: "pointer",
//                 transition: "all 0.3s ease",
//               }}
//               onMouseEnter={(e) =>
//                 (e.currentTarget.style.transform = "scale(1.08)")
//               }
//               onMouseLeave={(e) =>
//                 (e.currentTarget.style.transform = "scale(1)")
//               }
//             >
//               Close
//             </button>
//           </div>

//           <style>
//             {`
//               @keyframes fadeIn {
//                 from { opacity: 0; }
//                 to { opacity: 1; }
//               }
//               @keyframes scaleUp {
//                 from { transform: scale(0.8); opacity: 0; }
//                 to { transform: scale(1); opacity: 1; }
//               }
//             `}
//           </style>
//         </div>
//       )}
//     </>
//   );
// }

// export default Navbar;


import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [showQR, setShowQR] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const baseLinkStyle = {
    fontSize: "clamp(1rem, 1vw, 1.1rem)",
    fontWeight: "500",
    marginRight: "10px",
    textTransform: "uppercase",
    color: "#5a3a0e",
    transition: "all 0.4s ease",
    padding: "10px 16px",
    borderRadius: "8px",
    display: "inline-block",
    position: "relative",
  };

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About" },
    { path: "/verses", label: "Shlokas" },
    { path: "/healing", label: "Healing" },
    { path: "/resources", label: "Resources" },
    { path: "/achievements", label: "Achievements" },
    { path: "/contact", label: "Contact" },
  ];

  return (
    <>
      <nav
        className="navbar navbar-expand-lg"
        style={{
          background: isScrolled
            ? "rgba(255, 245, 230, 0.95)"
            : "linear-gradient(to right, #fff4dc, #ffe7ba, #ffd6b5)",
          backdropFilter: "blur(6px)",
          borderBottom: "1px solid rgba(255,255,255,0.4)",
          transition: "all 0.4s ease-in-out",
          boxShadow: isScrolled
            ? "0 4px 10px rgba(0,0,0,0.15)"
            : "0 0 0 rgba(0,0,0,0)",
          padding: isScrolled ? "4px 0" : "10px 0",
          zIndex: 1000,
          position: "sticky",
          top: 0,
        }}
      >
        <div className="container-fluid px-3 d-flex align-items-center justify-content-between">
          {/* 🔸 Logo + Brand */}
          <Link
            to="/"
            className="navbar-brand d-flex align-items-center"
            style={{ textDecoration: "none" }}
          >
            <img
              src="/logo.jpg"
              alt="Bhaktamar Logo"
              style={{
                width: "48px",
                height: "48px",
                borderRadius: "50%",
                objectFit: "cover",
                marginRight: "10px",
                boxShadow: "0 4px 10px rgba(255,180,100,0.4)",
                transition: "all 0.4s ease",
                transform: isScrolled ? "scale(0.95)" : "scale(1)",
              }}
            />
            <span
              style={{
                fontSize: "1.5rem",
                fontWeight: "700",
                color: "#5a3a0e",
                letterSpacing: "1px",
                textShadow: "0 0 8px rgba(255,255,255,0.7)",
              }}
            ></span>
          </Link>

          {/* 🔹 Mobile Toggle */}
          <button
            className="navbar-toggler border-0"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* 🔹 Nav Links */}
          <div
            className="collapse navbar-collapse justify-content-end align-items-center"
            id="navbarNav"
          >
            <ul
              className="navbar-nav align-items-center"
              style={{
                width: "100%",
                justifyContent: "flex-end",
                textAlign: "center",
              }}
            >
              {navLinks.map((item, idx) => (
                <li
                  key={idx}
                  onMouseEnter={() => setHoveredIndex(idx)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  className="nav-item"
                >
                  <Link
                    className="nav-link"
                    to={item.path}
                    style={{
                      ...baseLinkStyle,
                      color: hoveredIndex === idx ? "#fff" : "#4b2e05",
                      background:
                        hoveredIndex === idx
                          ? "linear-gradient(90deg,#f5b45a,#e8893a)"
                          : "transparent",
                      transform:
                        hoveredIndex === idx ? "translateY(-2px)" : "translateY(0)",
                      boxShadow:
                        hoveredIndex === idx
                          ? "0 4px 8px rgba(233,137,58,0.3)"
                          : "none",
                    }}
                  >
                    {item.label}
                    <span
                      style={{
                        position: "absolute",
                        left: 0,
                        bottom: 2,
                        width: hoveredIndex === idx ? "100%" : "0%",
                        height: "2px",
                        background: "#c26e18",
                        transition: "width 0.3s ease",
                      }}
                    ></span>
                  </Link>
                </li>
              ))}

              {/* 🪔 Yogdaan & Certificate Buttons */}
              <li
                className="nav-item d-flex align-items-center"
                style={{ gap: "10px" }}
              >
                {/* 🧾 Get Certificate Button (Fixed) */}
                <Link
                  to="/certificate"
                  style={{
                    background:
                      "linear-gradient(135deg, #91672c, #d9a441, #91672c)",
                    color: "#fff",
                    border: "none",
                    borderRadius: "10px",
                    padding: "8px 18px",
                    fontWeight: "600",
                    cursor: "pointer",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                    transition: "all 0.4s ease",
                    textDecoration: "none",
                    display: "inline-block",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.08)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                >
                  Get Certificate
                </Link>

                {/* 💰 Yogdaan Button */}
                <button
                  onClick={() => setShowQR(true)}
                  style={{
                    background:
                      "linear-gradient(135deg, #d97b29, #ffbb66, #d97b29)",
                    color: "#fff",
                    border: "none",
                    borderRadius: "10px",
                    padding: "8px 18px",
                    fontWeight: "600",
                    cursor: "pointer",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                    transition: "all 0.4s ease",
                    animation: "pulse 2.2s infinite",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.08)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                >
                  Yogdaan
                </button>
              </li>
            </ul>
          </div>
        </div>

        <style>
          {`
            @keyframes pulse {
              0% { box-shadow: 0 0 0 0 rgba(217,123,41, 0.6); }
              70% { box-shadow: 0 0 0 15px rgba(217,123,41, 0); }
              100% { box-shadow: 0 0 0 0 rgba(217,123,41, 0); }
            }
            @media (max-width: 992px) {
              .navbar-nav {
                flex-direction: column !important;
                align-items: center !important;
                gap: 6px;
                padding: 12px 0;
              }
            }
          `}
        </style>
      </nav>

      {/* 💰 Yogdaan Modal */}
      {showQR && (
        <div
          onClick={() => setShowQR(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
            animation: "fadeIn 0.4s ease-out",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background:
                "linear-gradient(to bottom right, #fff9ed, #fff3d5, #fff8e5)",
              borderRadius: "16px",
              padding: "30px 30px",
              textAlign: "center",
              boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
              maxWidth: "420px",
              width: "90%",
              transform: "scale(1)",
              animation: "scaleUp 0.4s ease-out",
            }}
          >
            <h4
              style={{
                color: "#5a3a0e",
                fontWeight: "700",
                marginBottom: "10px",
              }}
            >
              🙏 Bhaktamar Yogdaan
            </h4>
            <p style={{ color: "#654321", fontSize: "0.95rem" }}>
              Your kind contribution supports new features, growth, and
              spreading divine knowledge 🌸
            </p>

            <img
              src="/logo.jpg"
              alt="Yogdaan QR"
              style={{
                width: "220px",
                height: "220px",
                borderRadius: "10px",
                border: "2px solid #d6a76c",
                margin: "15px 0",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              }}
            />

            <div
              style={{
                color: "#4b2e05",
                fontSize: "0.9rem",
                background: "#fff4e0",
                padding: "12px",
                borderRadius: "10px",
                textAlign: "left",
                lineHeight: "1.6",
              }}
            >
              {/* You can add your donation info here */}
            </div>

            <button
              onClick={() => setShowQR(false)}
              style={{
                marginTop: "18px",
                background:
                  "linear-gradient(90deg, #d17b2c, #f0b35c, #d17b2c)",
                color: "#fff",
                border: "none",
                borderRadius: "10px",
                padding: "8px 22px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "scale(1.08)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            >
              Close
            </button>
          </div>

          <style>
            {`
              @keyframes fadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
              }
              @keyframes scaleUp {
                from { transform: scale(0.8); opacity: 0; }
                to { transform: scale(1); opacity: 1; }
              }
            `}
          </style>
        </div>
      )}
    </>
  );
}

export default Navbar;
